import { render, staticRenderFns } from "./Company_skills.vue?vue&type=template&id=13484653&scoped=true&lang=pug&"
import script from "./Company_skills.vue?vue&type=script&lang=coffee&"
export * from "./Company_skills.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13484653",
  null
  
)

export default component.exports